import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
// import './css/main.css'
import "./css/main.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
